<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100" v-if="isLoaded">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container
						ref="table"
						@OpenGridMesEqipPopup="OpenGridMesEqipPopup"
						:sendParam="sendParam"
						@PopupOpen="PopupOpen"
						@Refresh="Refresh"
						:scrId="scrId"
					/>
					<!--op코드 팝업-->
				</sf-card>
			</div>
			<!-- 팝업창 영역 시작-->
			<mes-eqip-no-popup ref="mesEqipNoPopup" :scrId="scrId" @SendData="sendData"></mes-eqip-no-popup>
			<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
			<!-- 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/TorqRgst/store/helpers';
import SearchContainer from './Search/Search.vue';
import TableContainer from './Table/Table.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
import mesEqipNoPopup from '@/views/qms/comm/commpopup/MesEqipNoPopup/MesEqipNoPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {}, //측정기관리코드 팝업
			isLoaded: false
		};
	},
	async created() {
		//MMCAD : 측정기 관리자, MMCWK: 측정기 업무처리자, MMCUR : 측정기 일반사용자, OS : 시스템 관리자
		this.setState_({ key: 'isMmcAdmin', value: await this.inclManyUsrGrp_(['MMCAD', 'OS']) });
		this.isLoaded = true;
	},
	components: { SearchContainer, TableContainer, mesEqipNoPopup, ExcelUploadModal },
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.searchContainer.searchList();
		},
		PopupOpen(param) {
			//this.userName = param.userName;
			// alert(this.$refs.searchView.userName);
			//this.$refs.searchView.open(param);
			// this.userName = param.userName;

			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		OpenGridMesEqipPopup(param) {
			const commCd = {
				eqipKndCd: param.eqipKndCd,
				mesEqipNm: param.mesEqipNo
			};
			this.$refs.mesEqipNoPopup.open(commCd); //.open(param);
		},
		sendData(param) {
			this.sendParam = param; //watch감시용
		}
	}
};
</script>

<style></style>
